export default __webpack_public_path__ + "static/media/arrowLeft.35339596.svg";